export const ResourceType = {
    DOCUMENT: 'document',
    XHR: 'xhr',
    BEACON: 'beacon',
    FETCH: 'fetch',
    CSS: 'css',
    JS: 'js',
    IMAGE: 'image',
    FONT: 'font',
    MEDIA: 'media',
    OTHER: 'other',
};
export const RequestType = {
    FETCH: ResourceType.FETCH,
    XHR: ResourceType.XHR,
};
//# sourceMappingURL=resourceUtils.js.map